import Vue from "vue";
import VueCookies from "vue-cookies";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VStripeElements from "v-stripe-elements/lib";
import CKEditor from "ckeditor4-vue";

import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import "./plugins/validate";
import { i18n } from "./plugins/i18n";
import store from "./store";
import { router } from "./router";
import * as moment from "moment";

import LoadScript from "vue-plugin-load-script";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(VStripeElements);
Vue.use(LoadScript);

Vue.use(VueCookies);
Vue.use(CKEditor);
moment.locale(i18n.locale);
Vue.filter("formatDate", (value) =>
  value != null ? moment(value).format("LL") : ""
);
Vue.filter("formatDateTime", (value) =>
  value != null ? moment(value).format("LLL") : ""
);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
